module.exports = __webpack_public_path__ + "img/ngvT.6e41ce3a.png";